import Swiper from 'swiper'
import { Navigation, Pagination, Manipulation } from 'swiper/modules'

import 'swiper/css'

export const customBooking = () => {
	fieldChanges()
	initBookingPage()
	navigateDates()
	additionalTickbox()
	additionalChanges()
}

const fieldChanges = () => {

	let forms = document.querySelectorAll('[data-custom-booking], [data-custom-booking-dropdown], [data-custom-booking-additional]')

	if (!forms.length) return

	forms.forEach(form => {

		let venue = form.querySelector('[data-custom-booking-field="venue"]'),
			type = form.querySelector('[data-custom-booking-field="type"]'),
			group_size = form.querySelector('[data-custom-booking-field="group_size"]'),
			group_toggles = form.querySelectorAll('[data-group-toggle]'),
			date = form.querySelector('[data-custom-booking-field="date"]'),
			time = form.querySelector('[data-custom-booking-field="time"]'),
			duration = form.querySelector('[data-custom-booking-field="duration"]'),
			additionalToggle = form.querySelector('[data-additional-toggle]')

		venue.addEventListener('change', () => {
			if (type) type.selectedIndex = 0
			if (date) date.selectedIndex = 0
			if (time) time.selectedIndex = 0
			if (duration) duration.selectedIndex = 0
			process(form, true, true, true, true)
		})

		type.addEventListener('change', () => {
			if (time) time.selectedIndex = 0
			if (duration) duration.selectedIndex = 0
			process(form, false, true, true, true)
		})

		if (group_size) {
			group_size.addEventListener('change', () => {
				process(form, false, true, true, true)
			})
			if (group_toggles.length) {
				group_toggles.forEach(group_toggle => {
					group_toggle.addEventListener('click', () => {
						const event = new Event('change', { bubbles: true });
						group_size.dispatchEvent(event);
						if (form.hasAttribute('data-custom-booking') && additionalToggle.checked) {
							let form = document.querySelector('[data-custom-booking-additional]')
							process(form, false, true, true, true)
						}
					})
				})
			}
		}

		if (date) {
			date.addEventListener('change', () => {
				if (duration) duration.selectedIndex = 0
				if (time) time.selectedIndex = 0
				process(form, false, true, true, true)
				if (form.hasAttribute('data-custom-booking') && additionalToggle.checked) {
					let form = document.querySelector('[data-custom-booking-additional]')
					process(form, false, true, true, true)
				}
			})
		}
		if (time) {
			time.addEventListener('change', () => {
				process(form, false, false, true, false)
				if (form.hasAttribute('data-custom-booking-additional')) {
					clearClickable('additional')
				} else {
					clearClickable()
				}
			})
		}
		if (duration) {
			duration.addEventListener('change', () => {
				process(form, false, false, false, false)
				if (type == '674dd43feb77cd679f65c402' || type == '674dd450a772d4526a64b8dd') {
					if (form.hasAttribute('data-custom-booking-additional')) {
						clearClickable('additional')
					} else {
						clearClickable()
					}
				}
			})
		}
	})
}

const initBookingPage = () => {

	let form = document.querySelector('[data-custom-booking]')

	if (!form) return

	process(form, true, true, true, true)
}

const navigateDates = () => {

	let buttons = document.querySelectorAll('[data-navigate-date]')

	if (!buttons.length) return

	let form = document.querySelector('[data-custom-booking]'),
		additionalForm = document.querySelector('[data-custom-booking-additional]')

	let time = form.querySelector('[data-custom-booking-field="time"]'),
		duration = form.querySelector('[data-custom-booking-field="duration"]'),
		additionalToggle = form.querySelector('[data-additional-toggle]'),
		additionalTime = additionalForm.querySelector('[data-custom-booking-field="time"]'),
		additionalDuration = additionalForm.querySelector('[data-custom-booking-field="duration"]')

	buttons.forEach(button => {
		button.addEventListener('click', () => {

			let input = document.querySelector('[data-load-namespace="custom-booking"] [data-datepicker]'),
				flatpickrInstance = input._flatpickr

			if (flatpickrInstance) {
				let currentDate = flatpickrInstance.selectedDates[0]

				if (currentDate) {
					let nextDate = new Date(currentDate)
					if (button.dataset.navigateDate == 'increase') {
						nextDate.setDate(nextDate.getDate() + 1)
					} else if (button.dataset.navigateDate == 'decrease') {
						let today = new Date()
						if (formatDate(nextDate) > formatDate(today)) {
							nextDate.setDate(nextDate.getDate() - 1)
						} else {
							console.log('Date is in the past')
						}
					}
					flatpickrInstance.setDate(nextDate)

					let summaryEl = document.querySelector('[data-summary-date]'),
						summaryDate = flatpickrInstance.formatDate(new Date(flatpickrInstance.currentYear, flatpickrInstance.currentMonth, flatpickrInstance.selectedDates[0]?.getDate() || new Date().getDate()), "F j, Y")

					if (summaryEl) summaryEl.textContent = 'on ' + summaryDate

					if (time) time.selectedIndex = 0
					if (duration) duration.selectedIndex = 0
					process(form, false, true, true, true)
				}

				if (additionalToggle && additionalToggle.checked) {
					if (additionalTime) time.selectedIndex = 0
					if (additionalDuration) duration.selectedIndex = 0
					process(additionalForm, false, true, true, true)
				}
			}
		})
	})
}

const additionalTickbox = () => {

	let tickbox = document.querySelector('[data-additional-checkbox]'),
		form = document.querySelector('[data-custom-booking-additional]')

	if (!tickbox) return

	tickbox.addEventListener('click', () => {
		process(form, true, true, true, true)
	})
}

const additionalChanges = () => {

	let type = document.querySelector('[data-custom-booking-field="additionalType"]'),
		time = document.querySelector('[data-custom-booking-field="additionalTime"]'),
		duration = document.querySelector('[data-custom-booking-field="additionalDuration"]')

	if (!type || !time || !duration) return

	let form = document.querySelector('[data-custom-booking-additional]')

	type.addEventListener('change', () => {
		let el = form.querySelector('[data-custom-booking-field="type"]')
		if (el) el.value = type.value
		const event = new Event('change', { bubbles: true });
		el.dispatchEvent(event);
	})

	time.addEventListener('change', () => {
		let el = form.querySelector('[data-custom-booking-field="time"]')
		if (el) el.value = time.value
		const event = new Event('change', { bubbles: true });
		el.dispatchEvent(event);
	})

	duration.addEventListener('change', () => {
		let el = form.querySelector('[data-custom-booking-field="duration"]')
		if (el) el.value = duration.value
		const event = new Event('change', { bubbles: true });
		el.dispatchEvent(event);
	})
}

const process = (form, resetType, resetTime, resetDuration, resetTimetable) => {

	loadingIcon(true)

	runAPI(form, false)
		.then(data => {
			// console.log('API Data [02]:', data)
			if (resetType) {
				let el = form.querySelector('[data-custom-booking-field="type"]'),
					additionalType = document.querySelector('[data-custom-booking-field="additionalType"]')
				let url = new URL(window.location.href),
					params = new URLSearchParams(url.search),
					selected = params.get('type')
				while (el.options.length > 1) el.remove(1)
				if (additionalType) while (additionalType.options.length > 1) additionalType.remove(1)
				if (data?.payload?.validation?.type?.suggestedValues) {
					data.payload.validation.type.suggestedValues.forEach(item => {
						if (!item.value.name.includes('Enquiry') && !item.value.name.includes('60') && !item.value.name.includes('90') && !item.value.name.includes('Darts & Shuffle')) {
							let option = document.createElement('option')
							option.textContent = item.value.name
							option.value = item.value.id
							if (selected && selected == item.value.id) {
								option.selected = true
								let label = form.querySelector('[data-timetable-label]')
								if (label) label.innerHTML = item.value.name
							}
							el.appendChild(option)
							if (form.hasAttribute('data-custom-booking-additional') && additionalType) {
								let option = document.createElement('option')
								option.textContent = item.value.name
								option.value = item.value.id
								additionalType.appendChild(option)
								if (selected && selected == item.value.id) {
									option.selected = true
									let label = document.querySelector('[data-timetable-additional-label]')
									if (label) label.innerHTML = item.value.name
								}
							}
						}
					})
				}
			}
			if (resetTime) {
				let el = form.querySelector('[data-custom-booking-field="time"]'),
					additionalTime = document.querySelector('[data-custom-booking-field="additionalTime"]')
				if (el) {
					while (el.options.length > 1) el.remove(1)
					if (form.hasAttribute('data-custom-booking-additional') && additionalTime) while (additionalTime.options.length > 1) additionalTime.remove(1)
					if (data?.payload?.validation?.time?.suggestedValues) {
						data.payload.validation.time.suggestedValues.forEach(item => {
							if (item.action !== 'reject') {
								let option = document.createElement('option')
								option.textContent = item.time
								option.value = item.time
								if (item.action == 'reject') option.disabled = true
								if (el.dataset.value == item.time) option.selected = 'selected'
								el.appendChild(option)
								if (form.hasAttribute('data-custom-booking-additional') && additionalTime) {
									let option = document.createElement('option')
									option.textContent = item.time
									option.value = item.time
									if (item.action == 'reject') option.disabled = true
									additionalTime.appendChild(option)
								}
							}
						})
					}
				}
			}
			if (resetDuration) {
				let el = form.querySelector('[data-custom-booking-field="duration"]'),
					additionalDuration = document.querySelector('[data-custom-booking-field="additionalDuration"]')
				if (el) {
					while (el.options.length > 1) el.remove(1);
					if (form.hasAttribute('data-custom-booking-additional') && additionalDuration) while (additionalDuration.options.length > 1) additionalDuration.remove(1)
					if (data?.payload?.validation?.duration?.suggestedValues) {
						data.payload.validation.duration.suggestedValues.forEach(item => {
							let option = document.createElement('option')
							option.textContent = item.value + 'mins'
							option.value = item.value
							if (item.action !== 'accept') option.disabled = true
							if (el.dataset.value == item.value) option.selected = 'selected'
							el.appendChild(option)
							if (form.hasAttribute('data-custom-booking-additional') && additionalDuration) {
								let option = document.createElement('option')
								option.textContent = item.value + 'mins'
								option.value = item.value
								if (item.action !== 'accept') option.disabled = true
								if (el.dataset.value == item.value) option.selected = 'selected'
								additionalDuration.classList.add('why')
								additionalDuration.appendChild(option)
							}
						})
					}
				}
			}
			if (!form.hasAttribute('data-custom-booking-dropdown') && resetTimetable && data.payload?.bookingDetails) {
				if (data.payload.bookingDetails.type == '674dd43feb77cd679f65c402' || data.payload.bookingDetails.type == '674dd450a772d4526a64b8dd') {
					generateTimetable(form, data, true)
				} else {
					generateTimetable(form, data, false)
				}
			} else {
				loadingIcon(false)
			}
			let messageContainer = form.querySelector('[data-message]')
			if (!form.hasAttribute('data-custom-booking-additional') && messageContainer) {
				messageContainer.dataset.message = data.payload.action
				let msg = ''
				if (data.payload.validation.type.errors) {
					msg = data.payload.validation.type.errors[0].message
				} else if (data.payload.validation.num_people.errors) {
					msg = data.payload.validation.num_people.errors[0].message
				} else if (data.payload.validation.date.errors) {
					msg = data.payload.validation.date.errors[0].message
				} else if (data.payload.validation.time.errors) {
					msg = data.payload.validation.time.errors[0].message
				} else if (data.payload.validation.duration.errors) {
					msg = data.payload.validation.duration.errors[0].message
				} else {
					messageContainer.dataset.message = ''
				}
				messageContainer.innerHTML = msg
			}

			let completeButton = form.querySelector('[data-custom-booking-complete-button]'),
				nextButton = form.querySelector('[data-custom-booking-step-button="next"]'),
				prevButton = form.querySelector('[data-custom-booking-step-button="prev"]')

			if (completeButton && nextButton && prevButton) {
				if (data.payload.action == 'accept' || data.payload.action == 'enquire') {
					completeButton.dataset.disabled = false
					nextButton.dataset.disabled = false
					prevButton.dataset.disabled = false
					// console.log('url: ', data.payload.next.web)
					Alpine.store('booking').setUrl(data.payload.next.web)
				} else {
					completeButton.dataset.disabled = true
					nextButton.dataset.disabled = true
					prevButton.dataset.disabled = true
				}
			}

		})
		.catch(error => {
			console.error('Error [03]:', error)
		})
}

const loadingIcon = flag => {

	let els = document.querySelectorAll('[data-loading-status]')

	if (!els.length) return

	els.forEach(el => {
		if (flag) {
			el.dataset.loadingStatus = 'loading'
		} else {
			el.dataset.loadingStatus = 'normal'
		}
	})
}

const runAPI = async (form, overrideDuration) => {

	const formData = new FormData(form)

	if (overrideDuration) {
		formData.set('duration', overrideDuration);
	}

	formData.forEach((value, key) => {
		// console.log(key, value)
	})

	try {
		const response = await fetch('/actions/custom-booking/booking/check-availability', {
			method: 'POST',
			headers: {
				'X-CSRF-Token': csrfTokenValue,
			},
			body: formData,
		})

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`)
		}

		const data = await response.json()
		return data
	} catch (error) {
		return { error: error.message }
	}
}

const generateTimetable = (form, data, game) => {

	let el = form.hasAttribute('data-custom-booking-additional') ? document.querySelector('[data-booking-swiper="additionalTimetable"]') : document.querySelector('[data-booking-swiper="timetable"]')

	if (!el) return

	let carousel = new Swiper(el, {
		modules: [Navigation, Pagination, Manipulation],
		slidesPerView: 1.8,
		centeredSlides: true,
		spaceBetween: 20,
		navigation: {
			nextEl: el.nextElementSibling.nextElementSibling,
			prevEl: el.nextElementSibling
		},
		breakpoints: {
			650: {
				slidesPerView: 3.75,
				centeredSlides: true,
			},
			782: {
				slidesPerView: 4,
				centeredSlides: true,
			},
			1400: {
				slidesPerView: 5,
				centeredSlides: true,
			},
		}
	})

	if (data?.payload?.validation?.time?.suggestedValues) {

		carousel.removeAllSlides()

		let slides = [],
			times = {}

		if (game == true) {

			let durations = ['60', '90']

			let promises = durations.map(duration => {
				return runAPI(form, duration)
					.then(data => {
						// console.log('API Data [01]:', data)
						if (data?.payload?.validation?.time?.suggestedValues) {
							data.payload.validation.time.suggestedValues.forEach(suggestedValue => {
								if (!times[suggestedValue.time.toString()]) times[suggestedValue.time.toString()] = []
								if (suggestedValue.action == 'accept' || suggestedValue.action == 'enquire') {
									times[suggestedValue.time.toString()][duration.toString()] = true
								}
							})
						}
					})
					.catch(error => {
						console.error('Error:', error)
					})
			})

			Promise.all(promises)
				.then(() => {
					Object.keys(times).forEach(key => {
						if (times[key].length !== 0) {
							let current = el.getAttribute('data-attempt-current'),
								html = current && key == current ? '<div class="swiper-slide" data-default-slide="">' : '<div class="swiper-slide">'
							html += '<div class="label">' + key + '</div>'
							html += '<div class="times">'
							if (form.hasAttribute('data-custom-booking-additional')) {
								if (times[key]['60']) {
									html += '<div class="time clickable is-additional" x-on:click="additionalDuration = 60; additionalTime = \'' + key + '\'">60mins</div>'
								} else {
									html += '<div class="time" data-status="disabled">60mins</div>'
								}
								if (times[key]['90']) {
									html += '<div class="time clickable is-additional" x-on:click="duration = null; time = null; $nextTick(() => { additionalDuration = 90; additionalTime = \'' + key + '\'; })">90mins</div>'
								} else {
									html += '<div class="time" data-status="disabled">90mins</div>'
								}
							} else {
								
								if (times[key]['60']) {
									html += '<div class="time clickable" x-on:click="duration = null; time = null; $nextTick(() => { duration = 60; time = \'' + key + '\'; })">60mins</div>'
								} else {
									html += '<div class="time" data-status="disabled">60mins</div>'
								}
								if (times[key]['90']) {
									html += '<div class="time clickable" x-on:click="duration = 90; time = \'' + key + '\'">90mins</div>'
								} else {
									html += '<div class="time" data-status="disabled">90mins</div>'
								}
							}
							html += '</div>'
							html += '</div>'
							slides.push(html)
						}
					})

					carousel.appendSlide(slides)

					let selectedSlideIndex = Array.from(carousel.slides).findIndex(slide =>
						slide.hasAttribute('data-default-slide')
					)

					if (selectedSlideIndex !== 0) {
						carousel.slideTo(selectedSlideIndex, 0, false)
					}

					let els = el.querySelectorAll('.clickable')

					els.forEach(el => {
						el.addEventListener('click', () => {
							setTimeout(() => {
								let elements = document.querySelectorAll('[data-default-slide]')
								elements.forEach(element => {
									element.removeAttribute('data-default-slide')
								})
								if (el.classList.contains('is-additional')) {
									clearClickable('additional')
								} else {
									clearClickable()
								}
								console.log('click')
								el.setAttribute('data-selected-time', true)
								setTimeout(() => {
									process(form, false, false, false, false)
								}, 1000);
							}, 100);
						})
					})

					loadingIcon(false)

				})
				.catch(error => {
					console.error('Error in all API calls:', error)
				})

			let select = form.querySelector('[data-custom-booking-field="duration"]'),
				additionalSelect = document.querySelector('[data-custom-booking-field="additionalDuration"]')

			if (select) {
				while (select.options.length > 1) select.remove(1);
				durations.forEach(duration => {
					let option = document.createElement('option')
					option.textContent = duration + 'mins'
					option.value = duration
					select.appendChild(option)
				})
			}

			if (form.hasAttribute('data-custom-booking-additional') && additionalSelect) {
				while (additionalSelect.options.length > 1) additionalSelect.remove(1);
				durations.forEach(duration => {
					let option = document.createElement('option')
					option.textContent = duration + 'mins'
					option.value = duration
					additionalSelect.appendChild(option)
				})
			}

		} else {

			data.payload.validation.time.suggestedValues.forEach((suggestedValue, i) => {
				let html = '<div class="swiper-slide" x-on:click="group_size = 4">'
				if (form.hasAttribute('data-custom-booking-additional')) {
					html += '<div class="label clickable is-additional" x-on:click="additionalTime = \'' + suggestedValue.time + '\'">' + suggestedValue.time + '</div>'
				} else {
					html += '<div class="label clickable" x-on:click="time = \'' + suggestedValue.time + '\'">' + suggestedValue.time + '</div>'
				}
				html += '</div>'
				slides[i] = html
			})

			carousel.appendSlide(slides)

			let selectedSlideIndex = Array.from(carousel.slides).findIndex(slide =>
				slide.hasAttribute('data-default-slide')
			)

			if (selectedSlideIndex !== 0) {
				carousel.slideTo(selectedSlideIndex, 0, false)
			}

			let els = el.querySelectorAll('.clickable')
			els.forEach(el => {
				el.addEventListener('click', () => {
					setTimeout(() => {
						if (el.classList.contains('is-additional')) {
							clearClickable('additional')
						} else {
							clearClickable()
						}
						el.setAttribute('data-selected-time', true)
						process(form, false, false, true, false)
					}, 100);
				})
			})

			loadingIcon(false)

		}
	}
}

const clearClickable = forAdditional => {

	let els = document.querySelectorAll('[data-selected-time]')

	els.forEach(el => {
		if (forAdditional) {
			if (el.classList.contains('is-additional')) {
				el.removeAttribute('data-selected-time')
			}
		} else {
			if (!el.classList.contains('is-additional')) {
				el.removeAttribute('data-selected-time')
			}
		}
	})
}

const formatDate = date => {

	let year = date.getFullYear(),
		day = String(date.getDate()).padStart(2, '0'),
		month = String(date.getMonth() + 1).padStart(2, '0')

	return `${year}${day}${month}`
}

export default () => { }